module.exports = __webpack_public_path__ + "static/media/time-interaccion.af99f6f8.svg";